import React from 'react'
import { FormattedMessage } from 'react-intl'
import AddOutlinedIcon from '@mui/icons-material/AddOutlined'
import Button, { ButtonProps as MuiButtonProps } from '@mui/material/Button'

const CreateTenantButton = (buttonProps: MuiButtonProps) => {
  return (
    <Button
      {...buttonProps}
      variant="outlined"
      color="secondary"
      startIcon={<AddOutlinedIcon />}
    >
      <FormattedMessage id={'createTenantForm.createTenantButton'} />
    </Button>
  )
}

export default CreateTenantButton
